import Header from "../../header";
import Footer from "../../footer";
import ContactForm from "../../contactcomponents/contactform";
import BannerFooter from "./bannerForFooter";
import unlock from '../../../images/cardpageimages/advanced/unlockmarketsecretimage.jpg';
function TradingEducation() {

    const keywords = [
        {
          title: "Trading and Education Resource",
          summary: "Access a wealth of trading resources and educational content to help you understand stock markets, trading strategies, and financial planning. Empower yourself with knowledge to make informed decisions."
        },
        {
          title: "Stock Market Basics",
          summary: "Learn the fundamentals of stock trading, including understanding market structure, types of stocks, and key trading strategies for beginners looking to invest in the stock market."
        },
        {
          title: "Cryptocurrency Insights",
          summary: "Explore the world of cryptocurrencies, blockchain technology, and trading strategies that will help you understand the dynamics of crypto markets and potential investment opportunities."
        },
        {
          title: "Forex Trading Guide",
          summary: "Gain insights into forex trading, including how currency markets work, trading pairs, exchange rates, and strategies for successful forex trading and risk management."
        },
        {
          title: "Mutual Funds Investment",
          summary: "Understand how mutual funds work and the benefits they offer for diversifying your portfolio. Learn about different types of mutual funds and how to choose the right ones for your goals."
        },
        {
          title: "Portfolio Management",
          summary: "Learn how to effectively manage your investment portfolio by balancing risk and reward, selecting diverse assets, and utilizing strategies to optimize long-term returns."
        },
        {
          title: "Technical Analysis",
          summary: "Master the art of technical analysis by using charts, indicators, and patterns to analyze market trends and make informed trading decisions based on historical price data."
        },
        {
          title: "Derivatives Trading",
          summary: "Understand the intricacies of derivatives such as futures, options, and swaps, and learn how to use these instruments for hedging, speculating, and managing risk in financial markets."
        },
        {
          title: "Investment Planning",
          summary: "Discover how to create a personalized investment plan that aligns with your financial goals. Learn strategies for building wealth, planning for retirement, and achieving long-term financial success."
        },
        {
          title: "Risk Assessment",
          summary: "Learn the importance of risk assessment in trading and investing. Understand how to identify, analyze, and mitigate risks to protect your investments from market volatility."
        }
      ];
      
    return (<>
        <Header />

        <BannerFooter
            title="Trading And Education Resource"
            text="The Trading and Education Resource provides valuable insights and tools for individuals looking to enhance their understanding of financial markets and trading strategies. It offers a comprehensive range of educational materials, from beginner to advanced levels, covering various asset classes such as stocks, futures, options, and commodities. The resource emphasizes practical applications, risk management, and technical analysis, empowering traders to make informed decisions. Whether you're a novice or an experienced investor, this platform offers the necessary knowledge and skills to navigate the dynamic trading landscape effectively. Stay updated with market trends and refine your strategies for success."
            imageone={unlock}
            imagetwo={unlock}
        />

<div className="container-fluid py-5 bg-light">
  <div className="container p-4 shadow-lg bg-white rounded">
    <h2 className="text-center mb-4">Trading and Education Resource</h2>
    <div className="accordion" id="investmentAccordion">
      {keywords.map((item, index) => (
        <div className="accordion-item" key={index}>
          <h2 className="accordion-header" id={`heading-${index}`}>
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target={`#collapse-${index}`}
              aria-expanded="false"
              aria-controls={`collapse-${index}`}
              style={{ transition: "all 0.3s ease" }}
            >
              {item.title}
            </button>
          </h2>
          <div
            id={`collapse-${index}`}
            className="accordion-collapse collapse"
            aria-labelledby={`heading-${index}`}
            data-bs-parent="#investmentAccordion"
          >
            <div className="accordion-body">
              {item.summary}
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
</div>

        <ContactForm/>


        <Footer />
    </>)
}

export default TradingEducation